export const MAIN_BUTTON_ID = 'copilot-dab-main-button';
